import { render, staticRenderFns } from "./PlanRetirementGeneralChart.vue?vue&type=template&id=5040f23a&scoped=true&"
import script from "./PlanRetirementGeneralChart.vue?vue&type=script&lang=js&"
export * from "./PlanRetirementGeneralChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5040f23a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
